import { configureStore } from '@reduxjs/toolkit'
import stockReducer from 'Reducers/stock'

export const store = configureStore({
  reducer: {
    stock: stockReducer
  },
})
